module.exports = __webpack_public_path__ + "img/Familytreeslide.c4aa480c.jpg";